import { option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { ResourceStateReasonClassification } from '@mews-commander/resources';
import { ApplicationState } from '@mews-commander/types';
import { TooltippedIcon } from '@mews-commander/ui';
import { IconName } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { ReservationTimeState } from '@mews-commander/data-access';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getReservation } from '@mews-commander/legacy-entities/src/ducks/reservations';
import { getResourceStateReasonClassification } from '@mews-commander/legacy-entities/src/ducks/resources';

interface OwnProps {
    reservationId: string;
}
interface StateProps {
    skipReservationCleaning: boolean;
    skipResourceCleaning: boolean;
}

const SkipCleaningDoorHanger = ({ skipReservationCleaning, skipResourceCleaning }: StateProps) =>
    skipReservationCleaning || skipResourceCleaning ? (
        <TooltippedIcon value={IconName.DoorHanger} tooltip={TextKey.TodayCleaningSkipped} />
    ) : null;

export default connect<StateProps, null, OwnProps, ApplicationState>((state, { reservationId }) => {
    const enterpriseId = getCurrentEnterpriseId();

    return pipe(
        option.fromNullable(getReservation(state, { id: reservationId, enterpriseId })),
        option.map(({ assignedResourceId, reservationTimeState, options: { skipCleaning } }) => ({
            skipReservationCleaning: skipCleaning,
            skipResourceCleaning:
                reservationTimeState === ReservationTimeState.CheckedIn && assignedResourceId
                    ? getResourceStateReasonClassification(state, {
                          id: assignedResourceId,
                          enterpriseId,
                      }) === ResourceStateReasonClassification.SkipCleaning
                    : false,
        })),
        option.getOrElse<StateProps>(() => ({ skipReservationCleaning: false, skipResourceCleaning: false }))
    );
})(SkipCleaningDoorHanger);
